import { InvoiceSettingsParams } from "@jugl-web/rest-api";
import { TextInput } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { FieldErrors, UseFormRegister } from "react-hook-form";

interface ZipCodeFieldProps {
  register: UseFormRegister<InvoiceSettingsParams>;
  errors: FieldErrors<InvoiceSettingsParams>;
  value: string;
}

const MAX_LENGTH = 20;

export const ZipCodeField = ({
  register,
  errors,
  value,
}: ZipCodeFieldProps) => {
  const { t } = useTranslations();

  return (
    <div>
      <TextInput
        placeholder={t({
          id: "common.enter",
          defaultMessage: "Enter",
        })}
        {...register("zipCode", {
          maxLength: {
            value: MAX_LENGTH,
            message: `${value.length}/${MAX_LENGTH}`,
          },
          setValueAs: (inputValue) => inputValue.trim(),
        })}
        isInvalid={!!errors.zipCode}
        label={t({
          id: "invoices.settings.businessInformation.zipCode",
          defaultMessage: "ZIP Code",
        })}
        errorMessage={errors.zipCode?.message ?? ""}
      />
    </div>
  );
};
